import { Tooltip as ReactTooltip } from "react-tooltip";
import { v4 as uuidV4 } from "uuid";

interface TruncatedTextProps {
  text: string;
  maxWidth?: string;
  className?: string;
  threshold?: number;
}

export const TruncatedText = ({
  text,
  maxWidth = "400px",
  className = "",
  threshold = 50,
}: TruncatedTextProps) => {
  const tooltipId = uuidV4();
  const showTooltip = text.length > threshold;

  return (
    <>
      <span
        data-tooltip-id={showTooltip ? tooltipId : undefined}
        data-tooltip-content={showTooltip ? text : undefined}
        className={`inline-block truncate align-middle ${className}`}
        style={{ maxWidth }}
      >
        {text}
      </span>
      {showTooltip && (
        <ReactTooltip
          id={tooltipId}
          className="!bg-brandDarkest !max-w-4xl !break-all !whitespace-normal !text-sm z-50"
        />
      )}
    </>
  );
};

export default TruncatedText;
